export default __webpack_public_path__ + "static/media/Walkera.e93a58d0.png";